module.exports = __webpack_public_path__ + "static/media/businesses-icon-2.782381d6.svg";